query INVESTOR ($email: String!) {
  isInvestor(email: $email) {
    error
    isInvestor
    shareableLink
    success
  }
}
